import { Button, Card } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import EmptyIcon from '@/shared/assets/empty-icon.svg?react';
import { useMediaQuery } from '@/shared/lib';
import { tv } from 'tailwind-variants';

const classes = tv({
  slots: {
    card: 'w-full p-[4.2rem] flex items-center justify-center rounded-[2.4rem]',
    wrapper: 'w-[30rem] flex flex-col items-center justify-center',
    iconWrapper:
      'w-[6.4rem] h-[6.4rem] flex items-center justify-center text-foreground mb-[3.2rem]',
    icon: 'w-[6.4rem] h-[6.4rem]',
    title: 'headline4 text-center mb-[0.8rem]',
    description: 'p4 text-center text-secondary whitespace-pre-line',
    button: 'rounded-full h-[4.2rem] mt-[3.2rem]',
    buttonText: 'headline4',
  },
  variants: {
    isMobile: {
      true: {
        card: 'p-[2.4rem]',
        wrapper: 'w-full',
        button: 'w-full',
      },
      false: {},
    },
  },
});

type Props = {
  isPeriodApplied: boolean;
  onPeriodReset: () => void;
};

export const EmptyStateView = ({ isPeriodApplied, onPeriodReset }: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 400px)');

  const c = classes({ isMobile });

  const localPath = isPeriodApplied
    ? 'emptyStateViewWithPeriod'
    : 'emptyStateView';

  return (
    <Card className={c.card()}>
      <div className={c.wrapper()}>
        <div className={c.iconWrapper()}>
          <EmptyIcon className={c.icon()} />
        </div>

        <h1 className={c.title()}>{t(`historyPage.${localPath}.title`)}</h1>

        <p className={c.description()}>
          {t(`historyPage.${localPath}.description`)}
        </p>

        {isPeriodApplied && (
          <Button
            variant="secondary"
            onClick={onPeriodReset}
            className={c.button()}>
            <span className={c.buttonText()}>
              {t(`historyPage.${localPath}.buttonText`)}
            </span>
          </Button>
        )}
      </div>
    </Card>
  );
};
